import { render, staticRenderFns } from "./intervention-files.vue?vue&type=template&id=254c6cd1&scoped=true&"
import script from "./intervention-files.vue?vue&type=script&lang=js&"
export * from "./intervention-files.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254c6cd1",
  null
  
)

export default component.exports